import React from 'react';
import PropTypes from 'prop-types';
import { Icon } from '@ontruck/orc';

import { isEmpty } from 'utils/types';

class Modal extends React.Component {
  constructor(props) {
    super(props);

    this.overlay = React.createRef();
    this.modal = React.createRef();

    this.handleKeyUp = this.handleKeyUp.bind(this);
    this.handleOutsideClick = this.handleOutsideClick.bind(this);
    this.handleInsideClick = this.handleInsideClick.bind(this);
  }

  componentDidMount() {
    window.addEventListener('keyup', this.handleKeyUp, false);

    if (
      this.overlay &&
      this.overlay.current &&
      !isEmpty(this.overlay.current)
    ) {
      this.overlay.current.addEventListener(
        'mousedown',
        this.handleOutsideClick,
        false
      );
    }

    if (this.modal && this.modal.current && !isEmpty(this.modal.current)) {
      this.modal.current.addEventListener(
        'mousedown',
        this.handleInsideClick,
        false
      );
    }
  }

  componentWillUnmount() {
    window.removeEventListener('keyup', this.handleKeyUp, false);

    if (
      this.overlay &&
      this.overlay.current &&
      !isEmpty(this.overlay.current)
    ) {
      this.overlay.current.removeEventListener(
        'mousedown',
        this.handleOutsideClick,
        false
      );
    }

    if (this.modal && this.modal.current && !isEmpty(this.modal.current)) {
      this.modal.current.removeEventListener(
        'mousedown',
        this.handleInsideClick,
        false
      );
    }
  }

  handleInsideClick = () => ({});

  handleKeyUp(e) {
    const { onClose } = this.props;
    const ESCAPE_KEY_CODE = 27;
    const keys = {
      [ESCAPE_KEY_CODE]: () => {
        e.preventDefault();
        onClose();
        window.removeEventListener('keyup', this.handleKeyUp, false);
      },
    };

    if (keys[e.keyCode]) {
      keys[e.keyCode]();
    }
  }

  handleOutsideClick(e) {
    const { onClose, allowClose } = this.props;

    if (
      allowClose &&
      this.modal &&
      this.modal.current &&
      !isEmpty(this.modal.current)
    ) {
      if (!this.modal.current.contains(e.target)) {
        onClose();
        if (
          this.overlay &&
          this.overlay.current &&
          !isEmpty(this.overlay.current)
        ) {
          this.overlay.current.removeEventListener(
            'click',
            this.handleOutsideClick,
            false
          );
        }
        e.stopPropagation();
      }
    }
  }

  render() {
    const {
      children,
      className,
      show,
      size,
      renderHeader,
      title,
      renderFooter,
      onClose,
      closeButton,
      fullHeight,
      sticky,
    } = this.props;

    return (
      <>
        {show && (
          <div className={`${className}`} ref={this.overlay}>
            <div className={`modal  ${size}`} ref={this.modal}>
              <div
                className={`content ${
                  closeButton || fullHeight ? 'flex' : ''
                } ${sticky ? 'sticky' : ''}`}
              >
                <>
                  {closeButton && (
                    <CloseButton onClose={onClose} title={title} />
                  )}
                </>
                <>{renderHeader && renderHeader()}</>
                <>{children}</>
                <>{renderFooter && renderFooter()}</>
              </div>
            </div>
          </div>
        )}
      </>
    );
  }
}

Modal.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  onClose: PropTypes.func,
  show: PropTypes.bool,
  size: PropTypes.string,
  renderHeader: PropTypes.func,
  renderFooter: PropTypes.func,
  closeButton: PropTypes.bool,
  title: PropTypes.string,
  fullHeight: PropTypes.bool,
  sticky: PropTypes.bool,
  allowClose: PropTypes.bool,
};

Modal.defaultProps = {
  children: null,
  className: '',
  onClose: () => ({}),
  show: false,
  closeButton: true,
  size: 'M',
  renderHeader: () => null,
  renderFooter: () => null,
  title: '',
  fullHeight: false,
  sticky: false,
  allowClose: true,
};

export default Modal;

const CloseButton = ({ onClose, title }) => (
  <div className="close-container">
    <div className="title">{title}</div>
    <button type="button" className="close" onClick={onClose}>
      <Icon glyph="close" color="grey500" size="16px" />
    </button>
  </div>
);

CloseButton.propTypes = {
  onClose: PropTypes.func,
  title: PropTypes.string,
};

CloseButton.defaultProps = {
  onClose: () => ({}),
  title: '',
};
